import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import AIDiagram from '../ui/AIDiagram';
import Icon from '../ui/Icon';
import { COMPANY, TRUSTED_LOGOS } from '../../data/site';

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show:   { opacity: 1, y: 0 },
};

export default function Hero() {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero__layout">
          <motion.div
            initial="hidden"
            animate="show"
            transition={{ staggerChildren: 0.08, delayChildren: 0.05 }}
          >
            <motion.div variants={fadeUp} transition={{ duration: 0.7, ease: [0.16, 0.84, 0.44, 1] }} className="hero__row">
              <span className="eyebrow"><span className="dot" />Voila Tech · v0.1.4</span>
              <span className="chip"><span className="dot" />{COMPANY.status}</span>
            </motion.div>

            <motion.h1 variants={fadeUp} transition={{ duration: 0.8, ease: [0.16, 0.84, 0.44, 1] }}>
              Intelligent <span className="em">Digital Products</span> built for business growth.
            </motion.h1>

            <motion.p variants={fadeUp} transition={{ duration: 0.7, ease: [0.16, 0.84, 0.44, 1] }} className="hero__sub">
              We help startups and growing brands turn ideas into intelligent digital products —
              AI automation, custom software, web apps, and mobile experiences engineered to
              compound advantage.
            </motion.p>

            <motion.div variants={fadeUp} transition={{ duration: 0.7, ease: [0.16, 0.84, 0.44, 1] }} className="hero__cta">
              <Link className="btn btn--primary btn--lg" to="/contact">
                Start a Project
                <Icon name="arrow" size={14} className="arrow" />
              </Link>
              <Link className="btn btn--ghost btn--lg" to="/services">Explore Services</Link>
            </motion.div>

            <motion.div variants={fadeUp} transition={{ duration: 0.7, ease: [0.16, 0.84, 0.44, 1] }} className="hero__metrics">
              <div className="hero__metric">
                <div className="num"><span className="accent">40+</span></div>
                <div className="label">Products shipped</div>
              </div>
              <div className="hero__metric">
                <div className="num">12 wk</div>
                <div className="label">Avg. v1 to launch</div>
              </div>
              <div className="hero__metric">
                <div className="num">98%</div>
                <div className="label">Client retention</div>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            className="hero__visual"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.15, ease: [0.16, 0.84, 0.44, 1] }}
          >
            <AIDiagram />
          </motion.div>
        </div>

        <motion.div
          className="trusted"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <div className="trusted__label">Trusted by founders building category-defining products</div>
          <div className="trusted__row">
            {TRUSTED_LOGOS.map((l) => (
              <div key={l.name} className={'trusted__logo ' + (l.variant !== 'default' ? l.variant : '')}>{l.name}</div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
